import * as Yup from "yup";

const priceStepValidation = Yup.object({
  price: Yup.number()
    .positive("Value must be a number")
    .min(1, "Value must be greater than 0")
    .required("Price type is required"),
  capacity: Yup.number()
    .positive("Value must be a number")
    .min(1, "Value must be greater than 0")
    .required("Units is required"),
  comission: Yup.number()
    .positive("Value must be a number")
    .min(1, "Value must be greater than 0")
    .required("Comission is required"),
  unit_name: Yup.string().required("Unit name is required"),
  price_description: Yup.string().optional().nullable(),
  offering: Yup.string().optional().nullable(),
});

export default priceStepValidation;
